import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const solutions = [
  {
    title: 'Sourcing Labor',
    desc:
      'Recruiting funnels, trade school partnerships, referral loops, and job board automation to keep crews staffed.',
  },
  {
    title: 'AI Software Solutions',
    desc:
      'Quoting assistants, work order triage, schedule optimization, and RFP drafting tuned to your workflows.',
  },
  {
    title: 'Logistics Planning',
    desc:
      'Routing, materials kitting, vendor SLAs, and last‑mile coordination to reduce idle time and callbacks.',
  },
  {
    title: 'Tailored Growth Strategies',
    desc:
      'Market positioning, channel testing, territory expansion, and profitability playbooks for blue‑collar leaders.',
  },
];

const ApplicationsSection = () => {
  return (
    <Box id="solutions" sx={{ py: 6 }}>
      <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
        Solutions for Blue‑Collar Companies
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph>
        Practical, ROI‑focused implementations your teams can adopt quickly.
      </Typography>
      <Grid container spacing={3}>
        {solutions.map((s, idx) => (
          <Grid item xs={12} md={6} key={idx}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700 }} gutterBottom>
                  {s.title}
                </Typography>
                <Typography color="text.secondary">{s.desc}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ApplicationsSection;


